import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

// Mirrors the loaded layout (map panel above a stack of Gantt rows) so the
// transition to real content doesn't shift the surrounding card.
const SKELETON_ROW_COUNT = 6;
const ROW_LABEL_WIDTH_IN_PX = 150;

interface TruckReplaySkeletonProps {
  // Optional caption shown beneath the map placeholder (e.g. fetch progress).
  progressLabel?: string;
}

const TruckReplaySkeleton = ({ progressLabel }: TruckReplaySkeletonProps) => {
  const theme = useTheme();

  return (
    <Box
      data-test-id="truck-replay-skeleton"
      sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 1 }}
    >
      <Skeleton
        variant="rectangular"
        sx={{ borderRadius: 1, height: 300, width: '100%' }}
      />

      {progressLabel ? (
        <Typography variant="body2" sx={{ color: theme.brandV2.colors.treadGray3 }}>
          {progressLabel}
        </Typography>
      ) : null}

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {Array.from({ length: SKELETON_ROW_COUNT }).map((_, index) => (
          <Box key={index} sx={{ alignItems: 'center', display: 'flex', gap: 1.5 }}>
            <Skeleton variant="text" sx={{ flex: `0 0 ${ROW_LABEL_WIDTH_IN_PX}px` }} />
            <Skeleton
              variant="rectangular"
              sx={{ borderRadius: 0.5, flex: 1, height: 22 }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default TruckReplaySkeleton;
